import React, { useRef, useEffect, useState } from "react";
import RegistrationService from "../../Services/Registration_Service";
import Service from "../../Services/Service";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  handleCustomChange,
  handleAddRow,
  toggleEditRow,
  deleteRow,
  validateFields,
} from "../../common";
import { Box, Stepper, Step, StepLabel, Select } from "@mui/material";
import Check from "@mui/icons-material/Check";
import BusinessIcon from "@mui/icons-material/Business";
import DescriptionIcon from "@mui/icons-material/Description";
import CategoryIcon from "@mui/icons-material/Category";
import PaymentIcon from "@mui/icons-material/Payment";
import GavelIcon from "@mui/icons-material/Gavel";
import { styled } from "@mui/material/styles";
import { Message } from "@mui/icons-material";
import "../../styles/Registration.css";

const steps = [
  "Vendor Information",
  "License Details",
  "Material Details",
  "Payment Details",
  "Declaration",
];

// let lvendorId = 0;
// let vAprvlStat = "";------------------------------------------------------
const RegistrationForm = (props) => {
  const [options, setOptions] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const tblPrtnrDtls = useRef(null);
  const [activeCard, setActiveCard] = useState(1);
  const [isDisabled, setIsDisabled] = useState(true);
  const [religions, setReligions] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [lvendorId, setLvendorId] = useState(0);

  const [isSaving, setIsSaving] = useState(false);

  const [isDirty, setIsDirty] = useState(false);

  const [documentFiles, setDocumentFiles] = useState({
    companyPanFile: null,
    companyGstinFile: null,
    drugLicenseFile: null,
    drugLicense2File: null,
  });

  const [documentPaths, setDocumentPaths] = useState({
    companyPanFilePath: "",
    companyGstinFilePath: "",
    drugLcnseFilePath: "",
    drugLcnse2FilePath: "",
  });
  const [gstApplicable, setGstApplicable] = useState(true);

  useEffect(() => {
    if (parseInt(sessionStorage.getItem("CategoryID")) > 0) {
      formData.CategoryID = sessionStorage.getItem("CategoryID");
      formData.VendorName = sessionStorage.getItem("VendorName");
      setIsVisible(false);
      setIsDisabled(true);
    } else {
      setIsVisible(true);
      setIsDisabled(false);
    }
    //debugger;
    RegistrationService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/Registration",
    );

    bindCategory();
    bindReligion();
    bindRegion();

    const fetchVendor = async () => {
      try {
        // debugger;
        const vendorId = props.vendorId || sessionStorage.getItem("VendorID");

        // If there is no VendorID, this is Add mode.
        // Don't call GetById with null.
        if (!vendorId || Number(vendorId) <= 0) {
          setLoading(false);
          return;
        }

        const res = await RegistrationService.getById(vendorId);
        const vendor = res.data?.[0];

        if (vendor) {
          setDocumentPaths({
            companyPanFilePath: vendor.companyPanFilePath ?? "",
            companyGstinFilePath: vendor.companyGstinFilePath ?? "",
            drugLcnseFilePath: vendor.drugLcnseFilePath ?? "",
            drugLcnse2FilePath: vendor.drugLcnse2FilePath ?? "",
          });
        }
        console.log(res.data[0]);
        console.log("FULL RESPONSE", res.data);

        console.log("CONTACT PERSONS", res?.data?.[0]?.listVndrCntctPrsnDtls);

        // formData.CategoryID = res.data[0].categoryID;
        // formData.VendorName = res.data[0].vendorName;

        // lvendorId = res.data[0].vendorId;
        // formData.VendorAddrs = res.data[0].vendorAddrs;
        // formData.VendorMfgLocation = res.data[0].vendorMfgLocation;
        // formData.VendorMfgAddrs = res.data[0].vendorMfgAddrs;
        // formData.compan = res.data[0].companyPan;
        // formData.comgst = res.data[0].companyGstin;
        // formData.dwlic = res.data[0].drugLcnseNo;
        // formData.dwissue = res.data[0].drugLcnseIssueDT;
        // formData.dwexpairy = res.data[0].drugLcnseExpiryDT;
        // formData.dmlic = res.data[0].drugLcnseNo2;
        // formData.dmissue = res.data[0].drugLcnse2IssueDT;
        // formData.dmexpairy = res.data[0].drugLcnse2ExpiryDT;
        // formData.brief = res.data[0].mfgDtls;
        // formData.paymentMethod = res.data[0].payMode;
        // formData.infavor = res.data[0].inFavour;
        // formData.bankname = res.data[0].bankName;
        // formData.accountNo = res.data[0].bankAccntNo;
        // formData.ifscCode = res.data[0].ifscCode;
        // formData.micrCode = res.data[0].micrCode;
        // formData.discountstracture = res.data[0].discStructr;
        // formData.tranfac = res.data[0].trnsportFclts;
        // formData.certificate = res.data[0].splyCertfct;
        // formData.SignaturePath = res.data[0].signaturePath;
        //lvendorId = res.data[0].vendorId;
        // lvendorId = res.data[0].vendorID;

        // setLvendorId(res.data[0].vendorID);
        // console.log("Assigned lvendorId =", lvendorId);

        const loadedVendorId = Number(res.data[0].vendorID);

        setLvendorId(loadedVendorId);
        sessionStorage.setItem("VendorID", loadedVendorId);

        console.log("Assigned VendorID =", loadedVendorId);

        const existingGST = (res.data[0].companyGstin ?? "").trim();

        setGstApplicable(
          existingGST.toUpperCase() !== "N/A" && existingGST !== "",
        );

        setFormData((prev) => ({
          ...prev,

          CategoryID: res.data[0].categoryID ?? "",
          VendorName: res.data[0].vendorName ?? "",
          VendorAddrs: res.data[0].vendorAddrs ?? "",
          VendorMfgLocation: res.data[0].vendorMfgLocation ?? "",
          VendorMfgAddrs: res.data[0].vendorMfgAddrs ?? "",

          compan: res.data[0].companyPan ?? "",
          comgst: res.data[0].companyGstin ?? "",

          dwlic: res.data[0].drugLcnseNo ?? "",
          dwissue: res.data[0].drugLcnseIssueDT ?? "",
          dwexpairy: res.data[0].drugLcnseExpiryDT ?? "",

          dmlic: res.data[0].drugLcnseNo2 ?? "",
          dmissue: res.data[0].drugLcnse2IssueDT ?? "",
          dmexpairy: res.data[0].drugLcnse2ExpiryDT ?? "",

          brief: res.data[0].mfgDtls ?? "",

          paymentMethod: res.data[0].payMode ?? "",
          infavor: res.data[0].inFavour ?? "",

          bankname: res.data[0].bankName ?? "",
          accountNo: res.data[0].bankAccntNo ?? "",
          ifscCode: res.data[0].ifscCode ?? "",
          micrCode: res.data[0].micrCode ?? "",

          discountstracture: res.data[0].discStructr ?? "",
          tranfac: res.data[0].trnsportFclts ?? "",
          certificate: res.data[0].splyCertfct ?? "",

          SignaturePath: res.data[0].signaturePath ?? "",
        }));
        setDirectors(
          (res?.data?.[0]?.listVndrPrtnrDtls || []).map((d) => ({
            PartnerName: d.partnerName ?? "",
            ContactNo: d.contactNo ?? "",
            MailID: "",
            PartnerType: "",
            readonly: true,
          })),
        );

        setDirectors((prev) => [
          ...prev,
          {
            PartnerName: "",
            ContactNo: "",
            MailID: "",
            PartnerType: "",
            readonly: false,
          },
        ]);

        // setkeypersons(
        //   (res?.data?.[0]?.listVndrCntctPrsnDtls || []).map((d) => ({
        //     authperson: d.authperson ?? "",
        //     authphone: d.authphone ?? "",
        //     email: d.mailID ?? "",
        //     // birthday: d.birthday ?? "",
        //     // anniversary: d.anniversary ?? "",
        //     birthday: d.birthday
        //       ? new Date(d.birthday).toISOString().split("T")[0]
        //       : "",

        //     anniversary: d.anniversary
        //       ? new Date(d.anniversary).toISOString().split("T")[0]
        //       : "",
        //     region: d.regionID ?? "",
        //     readonly: true,
        //   })),
        // );

        setkeypersons(
          (res?.data?.[0]?.listVndrCntctPrsnDtls || []).map((d) => ({
            authperson: d.authperson ?? "",
            authphone: d.authphone ?? "",
            email: d.mailID ?? "",
            // birthday: "",
            // anniversary: "",
            birthday: d.birthday
              ? d.birthday.split(" ")[0].split("/").reverse().join("-")
              : "",

            anniversary: d.anniversary
              ? d.anniversary.split(" ")[0].split("/").reverse().join("-")
              : "",
            region: d.regionID ?? "",
            readonly: true,
          })),
        );

        setkeypersons((prev) => [
          ...prev,
          {
            authperson: "",
            authphone: "",
            email: "",
            birthday: "",
            anniversary: "",
            region: "",
            readonly: false,
          },
        ]);

        setotherlic(
          (res?.data?.[0]?.listVndrOthrsLcnseDtls || []).map((d) => ({
            otherlicno: d.otherlicno ?? "",
            otherlicissue: d.otherlicissue ?? "",
            otherlicexpiry: d.otherlicexpiry ?? "",
            LicenseFilePath: d.licenseFilePath ?? "",
            licenseFile: null,
            readonly: true,
          })),
        );
        setotherlic((prev) => [
          ...prev,
          {
            otherlicno: "",
            otherlicissue: "",
            otherlicexpiry: "",
            LicenseFilePath: "",
            licenseFile: null,
            readonly: false,
          },
        ]);

        // res?.data?.[0]?.listVendorFinYrDtls.forEach((row, index) => {
        //   if (index == 0) formData.firstamount = row.finAmount;
        //   else if (index == 1) formData.secondamount = row.finAmount;
        //   else if (index == 2) formData.thirdamount = row.finAmount;
        // });

        setFormData((prev) => ({
          ...prev,
          firstamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[0]?.finAmount ?? "",
          secondamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[1]?.finAmount ?? "",
          thirdamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[2]?.finAmount ?? "",
        }));

        // res?.data?.[0]?.listVendorFinYrDtls.forEach((row, index) => {
        //   if (index == 0) formData.firstamount = row.finAmount;
        //   else if (index == 1) formData.secondamount = row.finAmount;
        //   else if (index == 2) formData.thirdamount = row.finAmount;
        // });

        setFormData((prev) => ({
          ...prev,
          firstamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[0]?.finAmount ?? "",
          secondamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[1]?.finAmount ?? "",
          thirdamount:
            res?.data?.[0]?.listVendorFinYrDtls?.[2]?.finAmount ?? "",
        }));

        // res?.data?.[0]?.listVndrOrgMtrxDtls.forEach((row, index) => {
        //   if (index == 0) {
        //     formData.ogname = row.personName;
        //     formData.ogphone = row.contactNo;
        //   } else if (index == 1) {
        //     formData.ogname2 = row.personName;
        //     formData.ogphone2 = row.contactNo;
        //   }
        // });
        setFormData((prev) => ({
          ...prev,
          ogname: res?.data?.[0]?.listVndrOrgMtrxDtls?.[0]?.personName ?? "",
          ogphone: res?.data?.[0]?.listVndrOrgMtrxDtls?.[0]?.contactNo ?? "",

          ogname2: res?.data?.[0]?.listVndrOrgMtrxDtls?.[1]?.personName ?? "",
          ogphone2: res?.data?.[0]?.listVndrOrgMtrxDtls?.[1]?.contactNo ?? "",
        }));

        setrm(
          (res?.data?.[0]?.listVndrItmDtls || []).map((d) => ({
            rmname: d.rmname ?? "",
            minqty: d.maxqty ?? 0,
            maxqty: d.minqty ?? 0,
            readonly: true,
          })),
        );

        setrm((prev) => [
          ...prev,
          { rmname: "", minqty: 0, maxqty: 0, readonly: false },
        ]);

        // let vTabID = parseInt(res.data[0].tabID);

        // if (vTabID == 5) setActiveCard(vTabID);
        // else setActiveCard(vTabID + 1);

        if (props.mode === "view") {
          setActiveCard(1); // Always open Vendor Information
        } else {
          let vTabID = parseInt(res.data[0].tabID);

          if (vTabID == 5) setActiveCard(vTabID);
          else setActiveCard(vTabID + 1);
        }

        setLoading(false);
      } catch (error) {
        //console.error("Error fetching vendor:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendor();
  }, []);

  // ADD THIS
  useEffect(() => {
    if (props.mode === "add") {
      setLvendorId(0);
    }
  }, [props.mode]);

  const bindCategory = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Category");
      //debugger;
      const res = await Service.getCategories(); // GET /api/Category
      //debugger;
      setOptions(res.data);
      //console.log(res.data);
      //console.log("FIRST CATEGORY =", res.data[0]);
    } catch (error) {
      //console.error("Error loading categories:", error);
      setOptions([]);
    }
  };

  const bindReligion = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Religion");
      const res = await Service.getAll();
      setReligions(res.data);
    } catch (error) {
      //console.error("Error loading religion:", error);
      setReligions([]);
    }
  };

  const bindRegion = async () => {
    try {
      Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Region");
      const res = await Service.getAll();
      setRegions(res.data);
    } catch (error) {
      //console.error("Error loading region:", error);
      setRegions([]);
    }
  };

  // const getPreviousFinancialYear = () => {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = today.getMonth() + 1;

  //   return month >= 4 ? `${year - 1}-${year}` : `${year - 2}-${year - 1}`;
  // };

  let getVndrStat = (vVndrStatus) => {
    if (vVndrStatus === "Vendor Information") vVndrStatus = "VI";
    else if (vVndrStatus === "License Details") vVndrStatus = "LD";
    else if (vVndrStatus === "Material Details") vVndrStatus = "MD";
    else if (vVndrStatus === "Payment Details") vVndrStatus = "PD";
    else vVndrStatus = "CP";
    return vVndrStatus;
  };

  // const getprePreviousFinancialYear = () => {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = today.getMonth() + 1;

  //   return month >= 4 ? `${year - 2}-${year}` : `${year - 3}-${year - 2}`;
  // };

  // const getPreviousFinancialYear2 = () => {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = today.getMonth() + 1;

  //   return month >= 4 ? `${year - 3}-${year}` : `${year - 4}-${year - 3}`;
  // };

  const getPreviousFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year - 1}-${year}`;
    } else {
      return `${year - 2}-${year - 1}`;
    }
  };

  const getPrePreviousFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year - 2}-${year - 1}`;
    } else {
      return `${year - 3}-${year - 2}`;
    }
  };

  const getThirdPreviousFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year - 3}-${year - 2}`;
    } else {
      return `${year - 4}-${year - 3}`;
    }
  };

  const [formData, setFormData] = useState({
    CategoryID: "", //new add
    VendorName: "",
    VendorAddrs: "",
    VendorMfgLocation: "",
    VendorMfgAddrs: "",
    name: "",
    authperson: "",
    authphone: "",
    mobilenumber: "",
    authemail: "",
    ogname: "",
    ogphone: "",
    ogname2: "",
    ogphone2: "",
    compan: "",
    comgst: "",
    dwlic: "",
    dwissue: "",
    dwexpairy: "",
    dmlic: "",
    dmissue: "",
    dmexpairy: "",
    firstyear: getPreviousFinancialYear(),
    secondyear: getPrePreviousFinancialYear(),
    thirdyear: getThirdPreviousFinancialYear(),
    firstamount: 0.0,
    secondamount: 0.0,
    thirdamount: 0.0,
    brief: "",
    paymentMethod: "",
    infavor: "",
    bankname: "",
    accountNo: "",
    ifscCode: "",
    micrCode: "",
    discountstracture: "",
    tranfac: "",
    certificate: "",

    VendorDOB: "",
    VendorAnniversary: "",
    // religion: "",
    // region: "",
    ReligionID: "",
    RegionID: "",
  });

  const [directorErrors, setDirectorErrors] = useState({});
  const [keypersonErrors, setKeypersonErrors] = useState({});
  const [otherLicErrors, setOtherLicErrors] = useState({});
  const [rmErrors, setRmErrors] = useState({});
  const [rmErrorIndex, setRmErrorIndex] = useState(null);
  const [directors, setDirectors] = useState([
    {
      PartnerName: "",
      ContactNo: "",
      MailID: "",
      PartnerType: "",
      readonly: false,
    },
  ]);

  const [keypersons, setkeypersons] = useState([
    {
      authperson: "",
      authphone: "",
      email: "",
      birthday: "",
      anniversary: "",
      region: "",
      readonly: false,
    },
  ]);
  const [otherlic, setotherlic] = useState([
    {
      otherlicno: "",
      otherlicissue: "",
      otherlicexpiry: "",
      LicenseFilePath: "",
      licenseFile: null,
      readonly: false,
    },
  ]);
  const [Rawmaterial, setrm] = useState([
    { rmname: "", minqty: 0, maxqty: 0, readonly: false },
  ]);
  const [errors, SetErrors] = useState({});

  // const validateLastMaterialRow = () => {
  //   const hasSavedRow = Rawmaterial.some(
  //     (row) =>
  //       row.readonly === true &&
  //       row.rmname?.trim() !== "" &&
  //       Number(row.minqty) >= 1 &&
  //       Number(row.maxqty) >= 1,
  //   );
  //   if (!hasSavedRow) {
  //     setRmErrors({
  //       _fieldset:
  //         "Please click the + button to add at least one material before proceeding",
  //     });
  //     return false;
  //   }
  //   // clear error once row is added
  //   setRmErrors({});
  //   return true;
  // };

  const validateLastMaterialRow = () => {
    const lastIndex = Rawmaterial.length - 1;
    const lastRow = Rawmaterial[lastIndex];

    // Check if there is at least one properly saved material
    const hasSavedRow = Rawmaterial.some(
      (row) =>
        row.readonly === true &&
        row.rmname?.trim() !== "" &&
        Number(row.minqty) >= 1 &&
        Number(row.maxqty) >= 1,
    );

    // If last row is not saved and user has entered something into it
    if (!lastRow.readonly) {
      const hasDraftValue =
        lastRow.rmname?.trim() !== "" ||
        Number(lastRow.minqty) > 0 ||
        Number(lastRow.maxqty) > 0;

      if (hasDraftValue) {
        setRmErrors({
          _fieldset:
            "Please click the + button to save the material details before proceeding.",
        });

        setRmErrorIndex(lastIndex);
        return false;
      }
    }

    // No saved material at all
    if (!hasSavedRow) {
      setRmErrors({
        _fieldset:
          "Please click the + button to add at least one material before proceeding.",
      });

      setRmErrorIndex(lastIndex);
      return false;
    }

    // Everything is valid
    setRmErrors({});
    setRmErrorIndex(null);

    return true;
  };
  const validateDirectorsDetailsRow = () => {
    const savedRow = directors.some(
      (row) =>
        row.readonly === true &&
        row.PartnerName?.trim() !== "" &&
        row.ContactNo?.trim() !== "",
    );

    if (!savedRow) {
      setDirectorErrors({
        _fieldset:
          "Please click the + button to add at least one contact details before proceeding",
      });
      return false;
    }

    // clear error once row is added
    setDirectorErrors({});
    return true;
  };

  const validateKeyContactPersonRow = () => {
    const saveRow = keypersons.some(
      (row) =>
        row.readonly === true &&
        row.authperson?.trim() !== "" &&
        row.authphone?.trim() !== "" &&
        row.email?.trim() !== "" &&
        row.region?.toString().trim() !== "",
    );

    if (!saveRow) {
      setKeypersonErrors({
        _fieldset:
          "Please click the + button to add at least one key contact person before proceeding",
      });
      return false;
    }

    // clear error once row is added
    setKeypersonErrors({});
    return true;
  };

  const isValidDecimal = (value) => {
    if (value === "" || value === null || value === undefined) return true;
    return /^\d+(\.\d+)?$/.test(value.toString().trim());
  };

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

  const ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png"];

  const handleDocumentFileChange = (e, fileKey) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();

    // Validate file type
    if (!ALLOWED_EXTENSIONS.includes(extension)) {
      SetErrors((prev) => ({
        ...prev,
        [fileKey]: "Only PDF, JPG, JPEG and PNG files are allowed.",
      }));

      e.target.value = "";
      return;
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      SetErrors((prev) => ({
        ...prev,
        [fileKey]: "File size must not exceed 5 MB.",
      }));

      e.target.value = "";
      return;
    }

    // Accept the file only when valid
    setDocumentFiles((prev) => ({
      ...prev,
      [fileKey]: file,
    }));

    SetErrors((prev) => ({
      ...prev,
      [fileKey]: "",
    }));

    setIsDirty(true);
  };

  const validation = () => {
    const newerrors = {};
    // PAN: ABCDE1234F
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // GST: 22ABCDE1234F1Z5
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    const micrRegex = /^[0-9]{9}$/;

    const accountRegex = /^[0-9]+$/;

    const bankRegex = /^[A-Za-z][A-Za-z.\s]*$/;

    const inFavorOfRegex = /^(?:N\/A|[A-Za-z](?:[A-Za-z .]*[A-Za-z])?\.?)$/i;
    const isEmpty = (v) =>
      v === null ||
      v === undefined ||
      (typeof v === "string" && v.trim() === "");

    // Validate only fields relevant to the current step
    if (activeCard === 1) {
      if (isEmpty(formData.VendorName))
        newerrors.VendorName = "Vendor Name is required.";
      // Category may be hidden (isVisible=false) when preset via session; only validate when visible
      if (isVisible && isEmpty(formData.CategoryID))
        newerrors.CategoryID = "Category is required.";
      if (isEmpty(formData.VendorAddrs))
        newerrors.VendorAddrs = "Vendor Address is required.";
      if (isEmpty(formData.VendorMfgLocation))
        newerrors.VendorMfgLocation = "Work Location is required.";
      if (isEmpty(formData.VendorMfgAddrs))
        newerrors.VendorMfgAddrs = " Manufacturing Unit Address is required.";

      // PAN validation
      if (isEmpty(formData.compan)) {
        newerrors.compan = "PAN Number is required.";
      } else if (!panRegex.test(formData.compan.toUpperCase())) {
        newerrors.compan = "Invalid PAN format (e.g. ABCDE1234F)";
      }

      // Company PAN Card file validation
      const hasPanFile =
        documentFiles.companyPanFile || documentPaths.companyPanFilePath;

      if (!hasPanFile) {
        newerrors.companyPanFile = "Please upload Company PAN Card.";
      }

      // GST Certificate file validation
      // Validate only when GST is applicable
      if (gstApplicable) {
        const hasGstFile =
          documentFiles.companyGstinFile || documentPaths.companyGstinFilePath;

        if (!hasGstFile) {
          newerrors.companyGstinFile =
            "Please upload GST Registration Certificate.";
        }
      }

      // GST validation
      // if (isEmpty(formData.comgst)) {
      //   newerrors.comgst = "GST Number is required.";
      // } else {
      //   const gstValue = formData.comgst.trim().toUpperCase();
      //   const panValue = formData.compan.trim().toUpperCase();

      //   // 1. Check GST format
      //   if (!gstRegex.test(gstValue)) {
      //     newerrors.comgst = "Invalid GST format (e.g. 22ABCDE1234F1Z5)";
      //   }

      //   // 2. Check GST embedded PAN against Company PAN
      //   else if (panValue && gstValue.substring(2, 12) !== panValue) {
      //     newerrors.comgst =
      //       "GST Number does not match the Company PAN Number.";
      //   }
      // }

      // GST validation only when GST is applicable
      if (gstApplicable) {
        if (isEmpty(formData.comgst)) {
          newerrors.comgst = "GST Number is required.";
        } else {
          const gstValue = formData.comgst.trim().toUpperCase();
          const panValue = formData.compan.trim().toUpperCase();

          if (!gstRegex.test(gstValue)) {
            newerrors.comgst = "Invalid GST format (e.g. 22ABCDE1234F1Z5)";
          } else if (panValue && gstValue.substring(2, 12) !== panValue) {
            newerrors.comgst =
              "GST Number does not match the Company PAN Number.";
          }
        }
      }

      // Organisation escalation matrix phone validation
      if (formData.ogphone && !/^[6-9]\d{9}$/.test(formData.ogphone)) {
        newerrors.ogphone =
          "Phone number must start with 6–9 and contain 10 digits";
      }

      if (formData.ogphone2 && !/^[6-9]\d{9}$/.test(formData.ogphone2)) {
        newerrors.ogphone2 =
          "Phone number must start with 6–9 and contain 10 digits";
      }
      // if (isEmpty(formData.VendorDOB))
      //   newerrors.VendorDOB = "Vendor DOB is required.";

      // if (isEmpty(formData.ReligionID))
      //   newerrors.ReligionID  = "Religion is required.";

      // if (isEmpty(formData.RegionID)) newerrors.RegionID = "Region is required.";
    }

    // Add other step validations as required (example placeholders)

    if (activeCard === 2) {
      // Production / manufacturing details
      if (!formData.brief || formData.brief.trim() === "") {
        newerrors.brief = "Production / Manufacturing details are required.";
      } else if (formData.brief.trim().length > 500) {
        newerrors.brief = "Maximum 500 characters are allowed.";
      }

      // Turnover amount validation
      if (!isValidDecimal(formData.firstamount)) {
        newerrors.firstamount = "Please enter a valid numeric amount.";
      }

      if (!isValidDecimal(formData.secondamount)) {
        newerrors.secondamount = "Please enter a valid numeric amount.";
      }

      if (!isValidDecimal(formData.thirdamount)) {
        newerrors.thirdamount = "Please enter a valid numeric amount.";
      }

      //Drug wholesaler license validation

      if (formData.dwissue && !formData.dwexpairy) {
        newerrors.dwexpairy = "Please select the expiry date.";
      }

      if (!formData.dwissue && formData.dwexpairy) {
        newerrors.dwissue = "Please select the issue date.";
      }

      if (
        formData.dwissue &&
        formData.dwexpairy &&
        new Date(formData.dwexpairy) <= new Date(formData.dwissue)
      ) {
        newerrors.dwexpairy = "Expiry date must be later than the issue date.";
      }

      // License number and date validation
      if ((formData.dwissue || formData.dwexpairy) && !formData.dwlic?.trim()) {
        newerrors.dwlic =
          "License Number is required when Issue Date or Expiry Date is entered.";
      }

      if (formData.dwlic?.trim()) {
        if (!formData.dwissue) {
          newerrors.dwissue =
            "Issue Date is required when License Number is entered.";
        }

        if (!formData.dwexpairy) {
          newerrors.dwexpairy =
            "Expiry Date is required when License Number is entered.";
        }
      }
      //Drug manufacturing license validation

      if (formData.dmissue && !formData.dmexpairy) {
        newerrors.dmexpairy = "Please select the expiry date.";
      }

      if (!formData.dmissue && formData.dmexpairy) {
        newerrors.dmissue = "Please select the issue date.";
      }

      if (
        formData.dmissue &&
        formData.dmexpairy &&
        new Date(formData.dmexpairy) <= new Date(formData.dmissue)
      ) {
        newerrors.dmexpairy = "Expiry date must be later than the issue date.";
      }
      // Manufacturing license number and date validation

      if ((formData.dmissue || formData.dmexpairy) && !formData.dmlic?.trim()) {
        newerrors.dmlic =
          "License Number is required when Issue Date or Expiry Date is entered.";
      }

      if (formData.dmlic?.trim()) {
        if (!formData.dmissue) {
          newerrors.dmissue =
            "Issue Date is required when License Number is entered.";
        }

        if (!formData.dmexpairy) {
          newerrors.dmexpairy =
            "Expiry Date is required when License Number is entered.";
        }
      }
    }

    // Payment Details validation
    if (activeCard === 4) {
      if (!formData.paymentMethod) {
        newerrors.paymentMethod = "Payment method is required";
      }

      if (!formData.infavor || formData.infavor.trim() === "") {
        newerrors.infavor = "In Favor Of is required";
      } else if (!inFavorOfRegex.test(formData.infavor.trim())) {
        newerrors.infavor = "Only letters, spaces, and periods are allowed";
      }

      // CHEQUE
      if (formData.paymentMethod === "Cheque") {
        if (!formData.bankname || formData.bankname.trim() === "") {
          newerrors.bankname = "Bank name is required for cheque payment";
        } else if (!bankRegex.test(formData.bankname)) {
          newerrors.bankname = "Only letters, spaces, and periods are allowed";
        }

        if (!formData.accountNo || formData.accountNo.trim() === "") {
          newerrors.accountNo = "Account number is required for cheque payment";
        } else if (!accountRegex.test(formData.accountNo)) {
          newerrors.accountNo = "Only digits are allowed";
        }
      }
      // NEFT/RTGS
      if (
        formData.paymentMethod === "NEFT" ||
        formData.paymentMethod === "RTGS"
      ) {
        if (!formData.bankname || formData.bankname.trim() === "") {
          newerrors.bankname = "Bank name is required";
        } else if (!bankRegex.test(formData.bankname)) {
          newerrors.bankname = "Only letters, spaces, and periods are allowed";
        }

        if (!formData.accountNo || formData.accountNo.trim() === "") {
          newerrors.accountNo = "Account number is required";
        } else if (!accountRegex.test(formData.accountNo)) {
          newerrors.accountNo = "Only digits are allowed";
        }

        if (!formData.ifscCode || formData.ifscCode.trim() === "") {
          newerrors.ifscCode = "IFSC code is required";
        } else if (!ifscRegex.test(formData.ifscCode.toUpperCase())) {
          newerrors.ifscCode = "Invalid IFSC code";
        }
      }
      // MICR validation
      const micrValue = formData.micrCode?.toString().trim() || "";

      // console.log("MICR VALUE:", micrValue);
      // console.log("MICR LENGTH:", micrValue.length);

      if (micrValue !== "" && !/^\d{9}$/.test(micrValue)) {
        newerrors.micrCode = "MICR code must contain exactly 9 digits";
      }
    }

    console.log("Length =", formData.brief.length);

    // update state and return pass/fail
    SetErrors(newerrors);
    return Object.keys(newerrors).length === 0;
  };

  //add 2  function for validation-----------------------------
  const isBankRequired = () =>
    formData.paymentMethod === "Cheque" ||
    formData.paymentMethod === "NEFT" ||
    formData.paymentMethod === "RTGS";

  const isIFSCRequired = () =>
    formData.paymentMethod === "NEFT" || formData.paymentMethod === "RTGS";

  const populateOrgEsclnMtrxDtls = () => {
    const orgMatrx = [];
    if (formData.ogname !== "" && formData.ogphone !== "") {
      orgMatrx.push({
        PersonName: formData.ogname,
        ContactNo: formData.ogphone,
        readonly: true,
      });
    }

    // Collect second entry if not empty
    if (formData.ogname2 !== "" && formData.ogphone2 !== "") {
      orgMatrx.push({
        PersonName: formData.ogname2,
        ContactNo: formData.ogphone2,
        readonly: true,
      });
    }
    return orgMatrx;
  };

  const populateTurnOverDtls = () => {
    const arrTurnOverDtls = [];
    if (formData.firstyear !== "" && formData.firstamount !== "") {
      arrTurnOverDtls.push({
        FinYr: formData.firstyear,
        // FinAmount: formData.firstamount,
        FinAmount: Number(parseFloat(formData.firstamount).toFixed(2)),
        readonly: true,
      });
    }

    // Collect second entry if not empty
    if (formData.secondyear !== "" && formData.secondamount !== "") {
      arrTurnOverDtls.push({
        FinYr: formData.secondyear,
        // FinAmount: formData.secondamount,
        FinAmount: Number(parseFloat(formData.secondamount).toFixed(2)),
        readonly: true,
      });
    }

    if (formData.thirdyear !== "" && formData.thirdamount !== "") {
      arrTurnOverDtls.push({
        FinYr: formData.thirdyear,
        // FinAmount: formData.thirdamount,
        FinAmount: Number(parseFloat(formData.thirdamount).toFixed(2)),
        readonly: true,
      });
    }
    //console.log(arrTurnOverDtls);
    return arrTurnOverDtls;
  };

  // const handleChange = (e) => {
  //   setIsDirty(true);
  //   //console.log(e.target.name, e.target.value);
  //   setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  //   // remove error while typing
  //   SetErrors({ ...errors, [e.target.name]: "" });
  // };

  const handleChange = (e) => {
    setIsDirty(true);

    let value = e.target.value;

    // Automatically convert Company PAN to uppercase
    if (e.target.name === "compan") {
      value = value.toUpperCase();
    }

    // Automatically convert GST to uppercase
    if (e.target.name === "comgst") {
      value = value.toUpperCase();
    }

    if (
      e.target.name === "firstamount" ||
      e.target.name === "secondamount" ||
      e.target.name === "thirdamount"
    ) {
      // Allow only one decimal point
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      // Remove leading zeros
      value = value.replace(/^0+(?=\d)/, "");
    }

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: value,
    }));

    // Remove error while typing
    SetErrors((prev) => ({
      ...prev,
      [e.target.name]: "",
    }));
  };

  const handleCustomChangeDirty = (index, e, list, setList) => {
    setIsDirty(true);

    handleCustomChange(index, e, list, setList);
  };
  const handleAddDirector = () => {
    const lastRow = directors[directors.length - 1];

    const errors = validateFields(lastRow, ["PartnerName", "ContactNo"]);

    if (lastRow.ContactNo && !/^[6-9]\d{9}$/.test(lastRow.ContactNo)) {
      errors.ContactNo =
        "Phone number must start with 6–9 and contain 10 digits";
    }
    // Duplicate Contact Number validation
    const duplicateContact = directors.some(
      (person, index) =>
        index !== directors.length - 1 &&
        person.ContactNo?.trim() === lastRow.ContactNo?.trim(),
    );

    if (duplicateContact) {
      errors.ContactNo =
        "This contact number is already used by another Director/Partner.";
    }
    if (Object.keys(errors).length > 0) {
      const rowErrors = {};
      rowErrors[directors.length - 1] = errors;

      setDirectorErrors(rowErrors);
      return;
    }

    setDirectorErrors({});

    const updatedList = directors.map((item, index) =>
      index === directors.length - 1 ? { ...item, readonly: true } : item,
    );

    setDirectors([
      ...updatedList,
      {
        PartnerName: "",
        ContactNo: "",
        MailID: "",
        PartnerType: "",
        readonly: false,
      },
    ]);
  };

  const handleEditDirector = (index) => {
    const row = directors[index];

    if (!row.readonly) {
      const errors = validateFields(row, ["PartnerName", "ContactNo"]);

      if (row.ContactNo && !/^[6-9]\d{9}$/.test(row.ContactNo)) {
        errors.ContactNo =
          "Phone number must start with 6–9 and contain 10 digits";
      }

      // Duplicate Contact Number validation
      const duplicateContact = directors.some(
        (person, personIndex) =>
          personIndex !== index &&
          person.ContactNo?.trim() &&
          row.ContactNo?.trim() &&
          person.ContactNo.trim() === row.ContactNo.trim(),
      );

      if (duplicateContact) {
        errors.ContactNo =
          "This contact number is already used by another Director/Partner.";
      }

      if (Object.keys(errors).length > 0) {
        const rowErrors = {};
        rowErrors[index] = errors;

        setDirectorErrors(rowErrors);
        return;
      }
    }

    setDirectorErrors({});
    toggleEditRow(index, directors, setDirectors);
  };

  // const handleAddkeycontact = () => {
  //   handleAddRow({
  //     list: keypersons,
  //     setList: setkeypersons,
  //     // requiredFields: ["authperson", "authphone"],
  //     requiredFields: [
  //       "authperson",
  //       "authphone",
  //       "email",
  //       "birthday",
  //       "region",
  //     ],
  //     // defaultItem: { authperson: "", authphone: "" },
  //     defaultItem: {
  //       authperson: "",
  //       authphone: "",
  //       email: "",
  //       birthday: "",
  //       anniversary: "",
  //       region: "",
  //     },
  //     setErrors: setKeypersonErrors,
  //   });
  // };

  const handleAddkeycontact = () => {
    const lastRow = keypersons[keypersons.length - 1];

    const errors = validateFields(lastRow, [
      "authperson",
      "authphone",
      "email",
      "region",
    ]);

    // Person Name validation
    if (
      lastRow.authperson &&
      !/^[A-Za-z]+(?:\s+[A-Za-z]+)*$/.test(lastRow.authperson.trim())
    ) {
      errors.authperson =
        "Person name should contain only alphabets and spaces.";
    }

    // Phone validation
    if (lastRow.authphone && !/^[6-9]\d{9}$/.test(lastRow.authphone)) {
      errors.authphone =
        "Phone number must start with 6–9 and contain 10 digits";
    }

    // Email validation
    if (lastRow.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lastRow.email)) {
      errors.email = "Please enter a valid email address";
    }

    // Duplicate phone validation
    const duplicatePhone = keypersons.some(
      (person, index) =>
        index !== keypersons.length - 1 &&
        lastRow.authphone?.trim() &&
        person.authphone?.trim() === lastRow.authphone.trim(),
    );

    if (duplicatePhone) {
      errors.authphone =
        "This phone number is already used by another key contact person.";
    }

    // Duplicate email validation
    const duplicateEmail = keypersons.some(
      (person, index) =>
        index !== keypersons.length - 1 &&
        lastRow.email?.trim() &&
        person.email?.trim().toLowerCase() ===
          lastRow.email.trim().toLowerCase(),
    );

    if (duplicateEmail) {
      errors.email =
        "This email address is already used by another key contact person.";
    }

    // Date validation
    const today = new Date().toISOString().split("T")[0];

    // Birthday cannot be a future date
    if (lastRow.birthday && lastRow.birthday > today) {
      errors.birthday = "Birthday cannot be a future date.";
    }

    // Anniversary cannot be a future date
    if (lastRow.anniversary && lastRow.anniversary > today) {
      errors.anniversary = "Anniversary cannot be a future date.";
    }

    // Anniversary cannot be before Birthday
    if (
      lastRow.birthday &&
      lastRow.anniversary &&
      lastRow.anniversary < lastRow.birthday
    ) {
      errors.anniversary =
        "Anniversary date cannot be earlier than Birthday date.";
    }
    if (Object.keys(errors).length > 0) {
      const rowErrors = {};

      rowErrors[keypersons.length - 1] = errors;

      setKeypersonErrors(rowErrors);
      return;
    }

    setKeypersonErrors({});

    const updatedList = keypersons.map((item, index) =>
      index === keypersons.length - 1 ? { ...item, readonly: true } : item,
    );

    setkeypersons([
      ...updatedList,
      {
        authperson: "",
        authphone: "",
        email: "",
        birthday: "",
        anniversary: "",
        region: "",
        readonly: false,
      },
    ]);
  };

  const handleEditKeyContact = (index) => {
    const row = keypersons[index];

    if (!row.readonly) {
      const validationRow = {
        ...row,
        authperson: row.authperson?.toString() || "",
        authphone: row.authphone?.toString() || "",
        email: row.email?.toString() || "",
        region: row.region?.toString() || "",
      };

      const errors = validateFields(validationRow, [
        "authperson",
        "authphone",
        "email",
        "region",
      ]);

      // Person Name validation
      if (
        row.authperson &&
        !/^[A-Za-z]+(?:\s+[A-Za-z]+)*$/.test(row.authperson.trim())
      ) {
        errors.authperson =
          "Person name should contain only alphabets and spaces.";
      }

      // Phone validation
      if (row.authphone && !/^[6-9]\d{9}$/.test(row.authphone)) {
        errors.authphone =
          "Phone number must start with 6–9 and contain 10 digits";
      }

      // Email validation
      if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) {
        errors.email = "Please enter a valid email address";
      }

      // Duplicate phone validation
      const duplicatePhone = keypersons.some(
        (person, personIndex) =>
          personIndex !== index &&
          person.authphone?.trim() &&
          row.authphone?.trim() &&
          person.authphone.trim() === row.authphone.trim(),
      );

      if (duplicatePhone) {
        errors.authphone =
          "This phone number is already used by another key contact person.";
      }

      // Duplicate email validation
      const duplicateEmail = keypersons.some(
        (person, personIndex) =>
          personIndex !== index &&
          person.email?.trim() &&
          row.email?.trim() &&
          person.email.trim().toLowerCase() === row.email.trim().toLowerCase(),
      );

      if (duplicateEmail) {
        errors.email =
          "This email address is already used by another key contact person.";
      }

      // Date validation
      const today = new Date().toISOString().split("T")[0];

      // Birthday cannot be a future date
      if (row.birthday && row.birthday > today) {
        errors.birthday = "Birthday cannot be a future date.";
      }

      // Anniversary cannot be a future date
      if (row.anniversary && row.anniversary > today) {
        errors.anniversary = "Anniversary cannot be a future date.";
      }

      // Anniversary cannot be before Birthday
      if (row.birthday && row.anniversary && row.anniversary < row.birthday) {
        errors.anniversary =
          "Anniversary date cannot be earlier than Birthday date.";
      }
      if (Object.keys(errors).length > 0) {
        const rowErrors = {};
        rowErrors[index] = errors;

        setKeypersonErrors(rowErrors);
        return;
      }
    }

    setKeypersonErrors({});
    toggleEditRow(index, keypersons, setkeypersons);
  };
  // const handleAddOtherlic = () => {
  //   handleAddRow({
  //     list: otherlic,
  //     setList: setotherlic,
  //     requiredFields: ["otherlicno", "otherlicissue", "otherlicexpiry"],
  //     defaultItem: { otherlicno: "", otherlicissue: "", otherlicexpiry: "" },
  //     setErrors: setOtherLicErrors,
  //   });
  // };

  const handleAddOtherlic = () => {
    const lastRow = otherlic[otherlic.length - 1];

    // Existing required validation
    const errors = validateFields(lastRow, [
      "otherlicno",
      "otherlicissue",
      "otherlicexpiry",
    ]);

    // License Number regex validation
    const licenseRegex = /^[A-Za-z0-9/._() -]{3,50}$/;

    if (
      lastRow.otherlicno?.trim() &&
      !licenseRegex.test(lastRow.otherlicno.trim())
    ) {
      errors.otherlicno =
        "License Number must be 3-50 characters and can contain only letters, numbers, spaces, /, -, ., _, (, ).";
    }

    // New date validation
    if (
      lastRow.otherlicissue &&
      lastRow.otherlicexpiry &&
      new Date(lastRow.otherlicexpiry) <= new Date(lastRow.otherlicissue)
    ) {
      errors.otherlicexpiry = "Expiry date must be later than issue date";
    }

    if (Object.keys(errors).length > 0) {
      const rowErrors = {};
      rowErrors[otherlic.length - 1] = errors;

      setOtherLicErrors(rowErrors);
      return;
    }

    setOtherLicErrors({});

    const updatedList = otherlic.map((item, index) =>
      index === otherlic.length - 1 ? { ...item, readonly: true } : item,
    );

    setotherlic([
      ...updatedList,
      {
        otherlicno: "",
        otherlicissue: "",
        otherlicexpiry: "",
        LicenseFilePath: "", // ADD THIS LINE
        licenseFile: null,
        readonly: false,
      },
    ]);
  };

  const handleEditOtherLic = (index) => {
    const row = otherlic[index];

    if (!row.readonly) {
      const errors = validateFields(row, [
        "otherlicno",
        "otherlicissue",
        "otherlicexpiry",
      ]);
      // License Number regex validation
      const licenseRegex = /^[A-Za-z0-9/._() -]{3,50}$/;

      if (row.otherlicno?.trim() && !licenseRegex.test(row.otherlicno.trim())) {
        errors.otherlicno =
          "License Number must be 3-50 characters and can contain only letters, numbers, spaces, /, -, ., _, (, ).";
      }

      if (
        row.otherlicissue &&
        row.otherlicexpiry &&
        new Date(row.otherlicexpiry) < new Date(row.otherlicissue)
      ) {
        errors.otherlicexpiry = "Expiry date cannot be earlier than issue date";
      }

      if (Object.keys(errors).length > 0) {
        const rowErrors = {};
        rowErrors[index] = errors;

        setOtherLicErrors(rowErrors);
        return;
      }
    }
    setOtherLicErrors({});

    toggleEditRow(index, otherlic, setotherlic);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleAddrm = () => {
    const lastRow = Rawmaterial[Rawmaterial.length - 1];
    const lastIndex = Rawmaterial.length - 1;

    const errors = {};

    if (!lastRow.rmname?.trim()) {
      errors.rmname = "Material name is required";
    }

    if (!lastRow.minqty || Number(lastRow.minqty) === 0) {
      errors.minqty = "Min Pack Size is required";
    } else if (Number(lastRow.minqty) < 0) {
      errors.minqty = "Negative values are not allowed";
    }

    if (!lastRow.maxqty || Number(lastRow.maxqty) === 0) {
      errors.maxqty = "Max Pack Size is required";
    } else if (Number(lastRow.maxqty) < 0) {
      errors.maxqty = "Negative values are not allowed";
    }

    if (Object.keys(errors).length > 0) {
      setRmErrors(errors);
      setRmErrorIndex(lastIndex);
      return;
    }

    if (Number(lastRow.maxqty) < Number(lastRow.minqty)) {
      setRmErrors({
        maxqty: "Max Pack cannot be less than Min Pack",
      });
      setRmErrorIndex(lastIndex);
      return;
    }
    // Duplicate Material Name validation
    const duplicateMaterial = Rawmaterial.some(
      (item, index) =>
        index !== lastIndex &&
        item.rmname?.trim() &&
        item.rmname.trim().toLowerCase() ===
          lastRow.rmname?.trim().toLowerCase(),
    );

    if (duplicateMaterial) {
      setRmErrors({
        rmname: "Material Name already added in list.",
      });
      setRmErrorIndex(lastIndex);
      return;
    }

    // Clear validation before adding new row
    setRmErrors({});
    setRmErrorIndex(null);

    handleAddRow({
      list: Rawmaterial,
      setList: setrm,
      requiredFields: ["rmname", "minqty", "maxqty"],
      defaultItem: {
        rmname: "",
        minqty: 0,
        maxqty: 0,
      },
      setErrors: setRmErrors,
    });
  };

  const handleEditRawMaterial = (index) => {
    const row = Rawmaterial[index];

    // Validate only when clicking Save/checkmark
    if (!row.readonly) {
      const errors = {};

      if (!row.rmname?.trim()) {
        errors.rmname = "Material name is required";
      }

      if (!row.minqty || Number(row.minqty) === 0) {
        errors.minqty = "Min Pack Size is required";
      } else if (Number(row.minqty) < 0) {
        errors.minqty = "Negative values are not allowed";
      }

      if (!row.maxqty || Number(row.maxqty) === 0) {
        errors.maxqty = "Max Pack Size is required";
      } else if (Number(row.maxqty) < 0) {
        errors.maxqty = "Negative values are not allowed";
      }

      if (row.minqty && row.maxqty && Number(row.maxqty) < Number(row.minqty)) {
        errors.maxqty = "Max Pack cannot be less than Min Pack";
      }

      // Duplicate Material Name validation
      const duplicateMaterial = Rawmaterial.some(
        (item, itemIndex) =>
          itemIndex !== index &&
          item.rmname?.trim() &&
          row.rmname?.trim() &&
          item.rmname.trim().toLowerCase() === row.rmname.trim().toLowerCase(),
      );

      if (duplicateMaterial) {
        errors.rmname = "Material Name already added in list.";
      }

      if (Object.keys(errors).length > 0) {
        setRmErrors(errors);
        setRmErrorIndex(index);
        return;
      }

      setRmErrors({});
      setRmErrorIndex(null);
    }

    toggleEditRow(index, Rawmaterial, setrm);
  };

  const uploadVendorDocuments = async (vendorId) => {
    // Check the four existing document fields
    const hasMainFiles = Object.values(documentFiles).some(
      (file) => file !== null,
    );

    // Check whether any Other License row has a newly selected file
    const hasOtherLicenseFiles = otherlic.some(
      (row) => row.licenseFile instanceof File,
    );

    // Do not call the API if no new files were selected
    if (!hasMainFiles && !hasOtherLicenseFiles) {
      return null;
    }

    const data = new FormData();

    data.append("vendorId", String(vendorId));
    data.append("vendorName", formData.VendorName);

    // 1. Add the existing four documents
    Object.entries(documentFiles).forEach(([key, file]) => {
      if (file) {
        data.append(key, file);
      }
    });

    // 2. Add Other License files and their row indexes
    const otherLicenseRows = [];

    otherlic.forEach((row, index) => {
      if (row.licenseFile instanceof File) {
        data.append("otherLicenseFiles", row.licenseFile);

        otherLicenseRows.push({
          index,
          otherlicno: row.otherlicno,
          otherlicissue: row.otherlicissue,
          otherlicexpiry: row.otherlicexpiry,
        });
      }
    });

    data.append("otherLicenseRows", JSON.stringify(otherLicenseRows));

    // DEBUG: Check what is being sent to the API
    console.log("Other License files:", data.getAll("otherLicenseFiles"));

    console.log("Other License rows:", data.get("otherLicenseRows"));

    try {
      const response = await RegistrationService.uploadVendorDocuments(data);

      console.log("Document upload response:", response.data);

      // Clear the four main document selections after success
      setDocumentFiles({
        companyPanFile: null,
        companyGstinFile: null,
        drugLicenseFile: null,
        drugLicense2File: null,
      });
      // Clear uploaded Other License file selections
      setotherlic((prev) =>
        prev.map((row) => ({
          ...row,
          licenseFile: null,
        })),
      );

      return response.data;
    } catch (error) {
      console.error(
        "Document upload failed:",
        error.response?.status,
        error.response?.data,
      );

      throw error;
    }
  };
  // const createRegistration = async (e) => {--------------------------------------------
  //"D" = Draft (Next button)"P" = Pending (Submit button)
  const createRegistration = async (e, aprvlStat = "D") => {
    //console.log("KEYPERSONS BEFORE API:", keypersons);
    // if (activeCard < 5) setActiveCard(activeCard + 1);
    e.preventDefault();
    //   const currentVendorId =
    // lvendorId > 0
    //   ? lvendorId
    //   : Number(sessionStorage.getItem("VendorID") || 0);

    // const currentVendorId =
    //   Number(props.vendorId) > 0
    //     ? Number(props.vendorId)
    //     : Number(lvendorId) > 0
    //       ? Number(lvendorId)
    //       : Number(sessionStorage.getItem("VendorID")) > 0
    //         ? Number(sessionStorage.getItem("VendorID"))
    //         : 0;

    const currentVendorId =
      Number(props.vendorId) > 0
        ? Number(props.vendorId)
        : Number(lvendorId) > 0
          ? Number(lvendorId)
          : Number(sessionStorage.getItem("VendorID")) > 0
            ? Number(sessionStorage.getItem("VendorID"))
            : 0;

    console.log("========== VENDOR ID DEBUG ==========");
    console.log("props.vendorId =", props.vendorId);
    console.log("lvendorId =", lvendorId);
    console.log("session VendorID =", sessionStorage.getItem("VendorID"));
    console.log("currentVendorId =", currentVendorId);
    console.log("Is valid number =", Number.isFinite(currentVendorId));
    console.log("=====================================");
    // const submissionData = {
    //   ...formData,
    //   directors,
    //   keypersons,
    //   otherlic,
    //   Rawmaterial,
    // };

    const gstValueToSave = gstApplicable
      ? (formData.comgst || "").trim().toUpperCase()
      : "N/A";

    const submissionData = {
      ...formData,
      comgst: gstValueToSave,
      directors,
      keypersons,
      otherlic,
      Rawmaterial,
    };
    console.log("createRegistration called");

    let vVndrStat = getVndrStat(steps[activeCard - 1]);
    try {
      // new 24
      setIsSaving(true);
      console.log("Sending VendorID =", currentVendorId);
      console.log(
        "Sending OpFlag =",
        currentVendorId > 0 ? "Update" : "Insert",
      );

      console.log("Before API");
      console.log("keypersons state =", keypersons);

      console.log("API URL =", sessionStorage.getItem("APIUrl"));
      console.log("UserEmail =", sessionStorage.getItem("userEmail"));
      console.log("TenantID =", sessionStorage.getItem("TenantID"));
      console.log("VendorID =", currentVendorId);
      console.log("OpFlag =", currentVendorId > 0 ? "Update" : "Insert");
      console.log("VndrStat =", vVndrStat);
      console.log("AprvlStat =", aprvlStat);

      await RegistrationService.create({
        CategoryID: formData.CategoryID,
        // ReligionID: formData.ReligionID,
        // RegionID: formData.RegionID,
        ReligionID: formData.ReligionID ? Number(formData.ReligionID) : null,

        RegionID: formData.RegionID ? Number(formData.RegionID) : null,
        VendorName: formData.VendorName,
        VendorAddrs: formData.VendorAddrs,
        VendorMfgLocation: formData.VendorMfgLocation,
        VendorMfgAddrs: formData.VendorMfgAddrs,
        VendorDOB: formData.VendorDOB,
        VendorAnniversary: formData.VendorAnniversary,
        CompanyPan: formData.compan,
        //CompanyGstin: formData.comgst,
        CompanyGstin: gstValueToSave,
        DrugLcnseNo: formData.dwlic,
        DrugLcnseIssueDT: formData.dwissue,
        DrugLcnseExpiryDT: formData.dwexpairy,
        DrugLcnseNo2: formData.dmlic,
        DrugLcnse2IssueDT: formData.dmissue,
        DrugLcnse2ExpiryDT: formData.dmexpairy,
        MfgDtls: formData.brief,
        PayMode: formData.paymentMethod,
        InFavour: formData.infavor,
        BankName: formData.bankname,
        BankAccntNo: formData.accountNo,
        IFSCCode: formData.ifscCode,
        MicrCode: formData.micrCode,
        DiscStructr: formData.discountstracture,
        TrnsportFclts: formData.tranfac,
        SplyCertfct: formData.certificate,
        SignaturePath: formData.SignaturePath,
        UserName: sessionStorage.getItem("userEmail") || "",
        CreatedByName: sessionStorage.getItem("empname") || "",
        // OpFlag: "Insert", // ← ADD HERE
        //OpFlag: lvendorId > 0 ? "Update" : "Insert",
        OpFlag: currentVendorId > 0 ? "Update" : "Insert",
        listVndrPrtnrDtls: directors,
        // listVndrCntctPrsnDtls: keypersons,
        // listVndrCntctPrsnDtls: keypersons.map((p) => ({
        //   authperson: p.authperson,
        //   authphone: p.authphone,
        //   MailID: p.email,
        //   Birthday: p.birthday,
        //   Anniversary: p.anniversary,
        //   RegionID: p.region,
        // })),

        //listVndrCntctPrsnDtls: keypersons.map((p) => ({ authperson: p.authperson || "", authphone: p.authphone || "", MailID: p.email || "", Birthday: p.birthday || null, Anniversary: p.anniversary || null, RegionID: Number(p.region) || 0, ContactPersonType: "", ContactPersonLevel: "" })),
        listVndrCntctPrsnDtls: keypersons
          .filter(
            (p) =>
              p.authperson ||
              p.authphone ||
              p.email ||
              p.birthday ||
              p.anniversary,
          )
          .map((p) => ({
            authperson: p.authperson,
            authphone: p.authphone,
            MailID: p.email,
            Birthday: p.birthday,
            Anniversary: p.anniversary,
            RegionID: Number(p.region) || 0,
            ContactPersonType: "",
            ContactPersonLevel: "",
          })),
        listVndrOthrsLcnseDtls: otherlic,
        listVndrItmDtls: Rawmaterial,
        listVndrOrgMtrxDtls: populateOrgEsclnMtrxDtls(),
        listVendorFinYrDtls: populateTurnOverDtls(),

        VndrStat: vVndrStat,
        //----------------------------------------------------------
        // AprvlStat: vAprvlStat,
        AprvlStat: aprvlStat,
        // vendorId: lvendorId,
        VendorID: currentVendorId,
        // }).then((Response) => {
        //   setLvendorId(Response.data.VendorID);

        //   console.log("Full Response =", Response);
        //   console.log("Response.data =", Response.data);

        //   console.log("Vendor ID =", Response.data.VendorID);

        //   sessionStorage.setItem("VendorID", Response.data.VendorID);
        // });

        //       }).then((Response) => {
        //  const newVendorID = Number(Response.data.VendorID);

        // setLvendorId(newVendorID);

        // console.log("Saved VendorID =", newVendorID);

        // if (newVendorID > 0) {
        //     sessionStorage.setItem("VendorID", String(newVendorID));
        // }

        //   // Move only after successful DB save
        //   if (aprvlStat === "D" && activeCard < 5) {
        //     setActiveCard(activeCard + 1);
        //   }
        // });
      }).then(async (Response) => {
        console.log("FULL SAVE RESPONSE =", Response.data);

        const newVendorID = Number(Response.data.vendorID?.value);

        console.log("Saved VendorID =", newVendorID);

        if (!newVendorID || newVendorID <= 0) {
          console.error("Invalid VendorID returned from API:", Response.data);
          return;
        }

        setLvendorId(newVendorID);

        sessionStorage.setItem("VendorID", newVendorID);

        setIsDirty(false);
        // Upload selected documents after registration is saved
        await uploadVendorDocuments(newVendorID);

        if (aprvlStat === "D" && activeCard < 5) {
          setActiveCard(activeCard + 1);
        }
      });

      if (vVndrStat === "CP") {
        alert(
          props.mode === "edit"
            ? "Vendor edited successfully!"
            : "Vendor added successfully!",
        );
        sessionStorage.removeItem("VendorID");
        props.onBack(); // go back only after final submit
      }

      console.log("keypersons =", keypersons);

      console.log(
        "Birthday values =",
        keypersons.map((x) => x.birthday),
      );
      // } catch (error) {
      //   //console.error("Error saving category:", error);
      // }
      //new 24
    } catch (error) {
      console.error("Error saving registration:", error);
    } finally {
      setIsSaving(false);
    }
    //console.log("Form submitted:\n" + JSON.stringify(submissionData, null, 2));
  };

  // const handleNext = (e) => {
  const handleNext = async (e) => {
    e.preventDefault();

    // VIEW MODE → only navigate, no validation and no API call
    if (props.mode === "view") {
      if (activeCard < 5) {
        setActiveCard(activeCard + 1);
      }
      return;
    }

    let isValid = true;

    // reset old errors (optional but recommended)
    // setDirectorErrors((prev) => ({ ...prev }));
    // setRmErrors((prev) => ({ ...prev }));

    // STEP 1 – Vendor Info + Directors + key contact
    if (activeCard === 1) {
      const directorValid = validateDirectorsDetailsRow(); // runs always
      const formValid = validation(); // runs always
      const keyContactValid = validateKeyContactPersonRow();

      isValid = directorValid && formValid && keyContactValid;
    }

    // STEP 3 – Material Details
    else if (activeCard === 3) {
      const materialValid = validateLastMaterialRow(); // runs always
      const formValid = validation(); // runs always

      isValid = materialValid && formValid;
    }

    // OTHER STEPS
    else {
      isValid = validation();
    }

    if (!isValid) {
      return; //  stop navigation
    }

    // createRegistration(e);
    // if (activeCard < 5) {
    //   setActiveCard(activeCard + 1); //  ONLY MOVE STEP
    // }

    // ==========================================
    // EDIT MODE + NOTHING CHANGED
    // ==========================================
    if (props.mode === "edit" && !isDirty) {
      if (activeCard < 5) {
        setActiveCard(activeCard + 1);
      }
      return;
    }

    // ADD MODE OR EDIT MODE + CHANGES
    // Save current step as Draft and then move to next step
    await createRegistration(e, "D");
  };

  const handlePrevious = () => {
    if (activeCard > 1) setActiveCard(activeCard - 1);
  };

  const stepIcons = {
    1: <BusinessIcon />,
    2: <DescriptionIcon />,
    3: <CategoryIcon />,
    4: <PaymentIcon />,
    5: <GavelIcon />,
  };

  const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor: ownerState.active ? theme.palette.primary.main : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.completed && {
      backgroundColor: theme.palette.success.main,
    }),
  }));

  // Custom StepIconComponent (JS-friendly)
  function StepIconComponent(props) {
    const { active, completed, className, icon } = props;

    return (
      <ColorlibStepIconRoot
        ownerState={{ active, completed }}
        className={className}
      >
        {completed ? <Check /> : stepIcons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  }

  const getProgress = () => (activeCard / 5) * 100;

  // const handleSubmit = (e) => {
  //   createRegistration(e);
  // };
  //---------------------------------------------------------------------------------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    // FINAL SUBMIT → send for approval
    await createRegistration(e, "P");
  };

  const renderCard = () => {
    switch (activeCard) {
      case 1:
        return (
          <>
            <h5 className="card-title mb-4">Vendor Information</h5>

            <label
              htmlFor="CategoryID"
              className="form-label"
              style={{ display: isVisible ? "block" : "none" }}
            >
              Category Name
              <span className="text-danger">*</span>
            </label>
            {/* <Select
              native
              name="CategoryID"
              value={formData.CategoryID}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.CategoryID ? "is-invalid" : ""}`}
              style={{ display: isVisible ? "block" : "none" }}
              aria-invalid={errors.CategoryID ? "true" : "false"}
              required
            > */}

            <select
              name="CategoryID"
              value={formData.CategoryID}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.CategoryID ? "is-invalid" : ""}`}
              style={{ display: isVisible ? "block" : "none" }}
              aria-invalid={errors.CategoryID ? "true" : "false"}
              required
            >
              <option value="">-- Select an option --</option>
              {/* {options.map((option) => (
                <option key={option.groupId} value={option.groupId}>
                  {option.groupName}
                </option>
              ))} */}
              {/* {options.map((option) => (
                <option key={option.CategoryID} value={option.CategoryID}>
                  {option.categoryName}
                </option>
              ))} */}

              {options.map((option) => (
                <option key={option.categoryId} value={option.categoryId}>
                  {" "}
                  {option.categoryName}{" "}
                </option>
              ))}
            </select>
            {errors.CategoryID && (
              <div className="text-danger mb-3">{errors.CategoryID}</div>
            )}

            <label htmlFor="VendorName" className="form-label">
              Vendor Name
              <span className="text-danger">*</span>
            </label>
            <input
              name="VendorName"
              value={formData.VendorName}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.VendorName ? "is-invalid" : ""}`}
              placeholder="Vendor Name"
              disabled={isDisabled}
            />
            {errors.VendorName && (
              <div className="text-danger mb-3">{errors.VendorName}</div>
            )}

            {/* Vendor DOB */}
            {/* <label className="form-label">
              Vendor DOB
              <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="VendorDOB"
              value={formData.VendorDOB}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.VendorDOB ? "is-invalid" : ""}`}
            />
            {errors.VendorDOB && (
              <div className="text-danger mb-2">{errors.VendorDOB}</div>
            )} */}

            {/* Vendor Anniversary */}
            {/* <label className="form-label">Vendor Anniversary</label>
            <input
              type="date"
              name="VendorAnniversary"
              value={formData.VendorAnniversary}
              onChange={handleChange}
              className="form-control mb-1"
            /> */}

            {/* Religion Dropdown */}
            {/* <label className="form-label">
              Religion
              <span className="text-danger">*</span>
            </label>
            <select
              name="ReligionID"
              value={formData.ReligionID}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.ReligionID ? "is-invalid" : ""}`}
            >
              <option value="">-- Select Religion --</option>

              {religions.map((r) => (
                <option key={r.religionId} value={r.religionId}>
                  {r.religionName}
                </option>
              ))}
            </select>
            {errors.ReligionID && (
              <div className="text-danger mb-2">{errors.ReligionID}</div>
            )} */}

            {/* Region Dropdown */}
            {/* <label className="form-label">
              Region
              <span className="text-danger">*</span>
            </label>
            <select
              name="RegionID"
              value={formData.RegionID}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.RegionID ? "is-invalid" : ""}`}
            >
              <option value="">-- Select Region --</option>

              {regions.map((r) => (
                <option key={r.regionId} value={r.regionId}>
                  {r.regionName}
                </option>
              ))}
            </select>
            {errors.RegionID && (
              <div className="text-danger mb-2">{errors.RegionID}</div>
            )} */}

            <label htmlFor="VendorAddrs" className="form-label">
              Vendor Address
              <span className="text-danger">*</span>
            </label>
            <textarea
              name="VendorAddrs"
              value={formData.VendorAddrs}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.VendorAddrs ? "is-invalid" : ""}`}
              placeholder="Vendor VendorAddrs"
            />
            {errors.VendorAddrs && (
              <div className="text-danger mb-3">{errors.VendorAddrs}</div>
            )}

            <label htmlFor="VendorMfgLocation" className="form-label">
              Manufacturing Unit Location
              <span className="text-danger">*</span>
            </label>
            <input
              name="VendorMfgLocation"
              value={formData.VendorMfgLocation}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.VendorMfgLocation ? "is-invalid" : ""}`}
              placeholder="Work/VendorMfgLocation Location"
            />
            {errors.VendorMfgLocation && (
              <div className="text-danger mb-3">{errors.VendorMfgLocation}</div>
            )}

            <label htmlFor="VendorMfgAddrs" className="form-label">
              Manufacturing Unit Address
              <span className="text-danger">*</span>
            </label>
            <textarea
              name="VendorMfgAddrs"
              value={formData.VendorMfgAddrs}
              onChange={handleChange}
              className={`form-control mb-1 ${errors.VendorMfgLocation ? "is-invalid" : ""}`}
              placeholder="VendorMfgLocation VendorAddrs"
            />
            {errors.VendorMfgAddrs && (
              <div className="text-danger mb-3">{errors.VendorMfgAddrs}</div>
            )}

            <fieldset
              className={`border p-3 mb-2 ${directorErrors._fieldset ? "border-danger" : ""}`}
            >
              <legend className="w-auto px-1">
                Name/s of Directors/Promoter/Proprietor/Partners and Contact
                Details<span className="text-danger">*</span>
              </legend>

              <table
                className="table table-bordered table-sm mb-0"
                ref={tblPrtnrDtls}
              >
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "45%" }}>Name</th>
                    <th style={{ width: "35%" }}>Contact Number</th>
                    <th style={{ width: "20%" }} className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {directors.map((director, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          name="PartnerName"
                          value={director.PartnerName}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              directors,
                              setDirectors,
                            )
                          }
                          className={`form-control form-control-sm ${
                            directorErrors[index]?.PartnerName
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Name"
                          readOnly={director.readonly}
                        />
                        {directorErrors[index]?.PartnerName && (
                          <div className="invalid-feedback">
                            {directorErrors[index]?.PartnerName}
                          </div>
                        )}
                      </td>
                      <td>
                        {/* <input
                          name="ContactNo"
                          value={director.ContactNo}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              directors,
                              setDirectors,
                            )
                          }
                          className={`form-control form-control-sm ${directorErrors.ContactNo && index === directors.length - 1 ? "is-invalid" : ""}`}
                          placeholder="Contact Number"
                          readOnly={director.readonly}
                        /> */}

                        <input
                          name="ContactNo"
                          value={director.ContactNo}
                          onChange={(e) => {
                            e.target.value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);

                            handleCustomChangeDirty(
                              index,
                              e,
                              directors,
                              setDirectors,
                            );
                          }}
                          className={`form-control form-control-sm ${
                            directorErrors[index]?.ContactNo ? "is-invalid" : ""
                          }`}
                          placeholder="Contact Number"
                          readOnly={director.readonly}
                        />
                        {directorErrors[index]?.ContactNo && (
                          <div className="invalid-feedback">
                            {directorErrors[index]?.ContactNo}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        {index === directors.length - 1 &&
                        !director.readonly ? (
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={handleAddDirector}
                            title="Add"
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm me-1"
                              onClick={() => handleEditDirector(index)}
                              title={director.readonly ? "Edit" : "Save"}
                            >
                              <i
                                className={`bi ${director.readonly ? "bi-pencil" : "bi-check-lg"}`}
                              ></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                deleteRow(index, directors, setDirectors)
                              }
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </fieldset>
            {directorErrors._fieldset && (
              <div className="text-danger  mb-4">
                {directorErrors._fieldset}
              </div>
            )}

            <fieldset
              className={`border p-3 mb-2 ${keypersonErrors._fieldset ? "border-danger" : ""}`}
            >
              <legend className="w-auto px-1">
                Key Contact Person(s)<span className="text-danger">*</span>
              </legend>
              <table className="table table-bordered table-sm mb-0">
                <thead className="table-light">
                  <tr>
                    <th colSpan="6">Contact Details</th>
                    <th style={{ width: "20%" }} className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                {/* <thead className="table-light">
                  <tr>
                    <th style={{ width: "45%" }}>Person Name</th>
                    <th style={{ width: "35%" }}>Phone Number</th>

                    <th>Email</th>
                    <th>Birthday</th>
                    <th>Anniversary</th>
                    <th>Region</th>

                    <th style={{ width: "20%" }} className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead> */}
                {/* <tbody>
                  {keypersons.map((person, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          name="authperson"
                          value={person.authperson}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className={`form-control form-control-sm ${keypersonErrors.authperson && index === keypersons.length - 1 ? "is-invalid" : ""}`}
                          placeholder="Person Name"
                          readOnly={person.readonly}
                        />
                        {keypersonErrors.authperson &&
                          index === keypersons.length - 1 && (
                            <div className="invalid-feedback">
                              {keypersonErrors.authperson}
                            </div>
                          )}
                      </td>
                      <td>
                        <input
                          name="authphone"
                          value={person.authphone}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className={`form-control form-control-sm ${keypersonErrors.authphone && index === keypersons.length - 1 ? "is-invalid" : ""}`}
                          placeholder="Phone Number"
                          readOnly={person.readonly}
                        />
                        {keypersonErrors.authphone &&
                          index === keypersons.length - 1 && (
                            <div className="invalid-feedback">
                              {keypersonErrors.authphone}
                            </div>
                          )}
                      </td>
                      <td>
                        <input
                          name="email"
                          value={person.email}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className="form-control form-control-sm"
                          placeholder="Email"
                          readOnly={person.readonly}
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          name="birthday"
                          value={person.birthday}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className="form-control form-control-sm"
                          readOnly={person.readonly}
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          name="anniversary"
                          value={person.anniversary}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className="form-control form-control-sm"
                          readOnly={person.readonly}
                        />
                      </td>

                      <td>
                        <select
                          name="RegionID"
                          value={person.region}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              keypersons,
                              setkeypersons,
                            )
                          }
                          className="form-control form-control-sm"
                          disabled={person.readonly}
                        >
                          <option value="">--Select--</option>
                          {regions.map((r) => (
                            <option key={r.regionId} value={r.regionId}>
                              {r.regionName}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="text-center">
                        {index === keypersons.length - 1 && !person.readonly ? (
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={handleAddkeycontact}
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm me-1"
                              onClick={() =>
                                toggleEditRow(index, keypersons, setkeypersons)
                              }
                              title={person.readonly ? "Edit" : "Save"}
                            >
                              <i
                                className={`bi ${person.readonly ? "bi-pencil" : "bi-check-lg"}`}
                              ></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                deleteRow(index, keypersons, setkeypersons)
                              }
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody> */}

                <tbody>
                  {keypersons.map((person, index) => (
                    <React.Fragment key={index}>
                      {/* ROW 1 */}
                      <tr>
                        <td colSpan="2">
                          <input
                            name="authperson"
                            value={person.authperson}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.authperson
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Person Name"
                            readOnly={person.readonly}
                          />
                          {keypersonErrors[index]?.authperson && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index]?.authperson}
                            </div>
                          )}
                        </td>

                        <td colSpan="2">
                          {/* <input
                            name="authphone"
                            value={person.authphone}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors.authphone &&
                              index === keypersons.length - 1
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Phone Number"
                            readOnly={person.readonly}
                          /> */}

                          <input
                            name="authphone"
                            value={person.authphone}
                            onChange={(e) => {
                              e.target.value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              );
                            }}
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.authphone
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Phone Number"
                            readOnly={person.readonly}
                          />
                          {keypersonErrors[index]?.authphone && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index]?.authphone}
                            </div>
                          )}
                        </td>
                        <td colSpan="2">
                          <input
                            name="email"
                            value={person.email}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.email ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            readOnly={person.readonly}
                          />

                          {keypersonErrors[index]?.email && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index]?.email}
                            </div>
                          )}
                        </td>
                        <td rowSpan="2" className="text-center align-middle">
                          {index === keypersons.length - 1 &&
                          !person.readonly ? (
                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={handleAddkeycontact}
                              title="Add"
                            >
                              <i className="bi bi-plus"></i>
                            </button>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="btn btn-primary btn-sm me-1"
                                onClick={() => handleEditKeyContact(index)}
                                title={person.readonly ? "Edit" : "Save"}
                              >
                                <i
                                  className={`bi ${person.readonly ? "bi-pencil" : "bi-check-lg"}`}
                                ></i>
                              </button>

                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  deleteRow(index, keypersons, setkeypersons)
                                }
                                title="Delete"
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </>
                          )}
                        </td>
                      </tr>

                      {/* ROW 2 */}

                      <tr>
                        <td colSpan="2">
                          <input
                            type={person.birthday ? "date" : "text"}
                            name="birthday"
                            value={person.birthday}
                            placeholder="Birthday"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => {
                              if (!e.target.value) e.target.type = "text";
                            }}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.birthday
                                ? "is-invalid"
                                : ""
                            }`}
                            readOnly={person.readonly}
                          />

                          {keypersonErrors[index]?.birthday && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index].birthday}
                            </div>
                          )}
                        </td>

                        <td colSpan="2">
                          <input
                            type={person.anniversary ? "date" : "text"}
                            name="anniversary"
                            value={person.anniversary}
                            placeholder="Anniversary"
                            onFocus={(e) => (e.target.type = "date")}
                            onBlur={(e) => {
                              if (!e.target.value) e.target.type = "text";
                            }}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.anniversary
                                ? "is-invalid"
                                : ""
                            }`}
                            readOnly={person.readonly}
                          />

                          {keypersonErrors[index]?.anniversary && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index].anniversary}
                            </div>
                          )}
                        </td>

                        <td colSpan="2">
                          <select
                            name="region"
                            value={person.region}
                            onChange={(e) =>
                              handleCustomChangeDirty(
                                index,
                                e,
                                keypersons,
                                setkeypersons,
                              )
                            }
                            className={`form-control form-control-sm ${
                              keypersonErrors[index]?.region ? "is-invalid" : ""
                            }`}
                            disabled={person.readonly}
                          >
                            <option value="">--Select Region--</option>

                            {regions.map((r) => (
                              <option key={r.regionId} value={r.regionId}>
                                {r.regionName}
                              </option>
                            ))}
                          </select>

                          {keypersonErrors[index]?.region && (
                            <div className="invalid-feedback">
                              {keypersonErrors[index].region}
                            </div>
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </fieldset>
            {keypersonErrors._fieldset && (
              <div className="text-danger  mb-4">
                {keypersonErrors._fieldset}
              </div>
            )}

            <fieldset className="border p-3 mb-4">
              <legend className="w-auto px-2">
                Organisation Escalation Matrix (other than key contact person)
              </legend>
              <div className="row">
                <div className="col-md-6">
                  <input
                    name="ogname"
                    value={formData.ogname}
                    onChange={handleChange}
                    className="form-control mb-2"
                    placeholder="Level 1 Contact Name"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="ogphone"
                    value={formData.ogphone}
                    onChange={(e) => {
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);

                      handleChange(e);
                    }}
                    className={`form-control mb-2 ${
                      errors.ogphone ? "is-invalid" : ""
                    }`}
                    placeholder="Level 1 Phone Number"
                  />

                  {errors.ogphone && (
                    <div className="text-danger">{errors.ogphone}</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <input
                    name="ogname2"
                    value={formData.ogname2}
                    onChange={handleChange}
                    className="form-control mb-2"
                    placeholder="Level 2 Contact Name"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="ogphone2"
                    value={formData.ogphone2}
                    onChange={(e) => {
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);

                      handleChange(e);
                    }}
                    className={`form-control mb-2 ${
                      errors.ogphone2 ? "is-invalid" : ""
                    }`}
                    placeholder="Level 2 Phone Number"
                  />

                  {errors.ogphone2 && (
                    <div className="text-danger">{errors.ogphone2}</div>
                  )}
                </div>
              </div>
            </fieldset>

            <label htmlFor="compan" className="form-label">
              Company's PAN Number
              <span className="text-danger">*</span>
            </label>
            <div className="input-group mb-1">
              <input
                name="compan"
                value={formData.compan}
                onChange={handleChange}
                className={` form-control mb-1 ${errors.compan ? "is-invalid" : ""}`}
                placeholder="Company's PAN Number"
              />
            </div>
            {errors.compan && (
              <div className="text-danger mb-3">{errors.compan}</div>
            )}

            <div className="mb-4">
              <label className="form-label ">
                Upload Company PAN Card <span className="text-danger">*</span>
              </label>

              <label className="document-upload-box" htmlFor="companyPanFile">
                <i className="bi bi-file-earmark-arrow-up upload-icon"></i>

                <span className="upload-title">
                  {documentFiles.companyPanFile
                    ? documentFiles.companyPanFile.name
                    : "Choose PAN card file"}
                </span>

                <span className="upload-hint">
                  PDF, JPG or PNG · Maximum 5 MB
                </span>
              </label>

              <input
                id="companyPanFile"
                type="file"
                hidden
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleDocumentFileChange(e, "companyPanFile")}
              />
              {errors.companyPanFile && (
                <div className="text-danger mt-2">{errors.companyPanFile}</div>
              )}

              {documentPaths.companyPanFilePath && (
                <div className="mt-2">
                  <a
                    href={RegistrationService.getDocumentUrl(
                      documentPaths.companyPanFilePath,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open existing PAN document
                  </a>
                </div>
              )}
            </div>

            {/* <label htmlFor="comgst" className="form-label">
              Company's GST Number
              <span className="text-danger">*</span>
            </label>
            <input
              name="comgst"
              value={formData.comgst}
              onChange={handleChange}
              className={` form-control mb-1 ${errors.comgst ? "is-invalid" : ""}`}
              placeholder="Company's GST Number"
            />
            {errors.comgst && (
              <div className="text-danger mb-3">{errors.comgst}</div>
            )} */}

            <div className="mb-3">
              <label htmlFor="comgst" className="form-label">
                Company's GST Number
                <span className="text-danger">*</span>
              </label>

              <div className="form-check mb-2">
                <input
                  id="gstApplicable"
                  type="checkbox"
                  className="form-check-input"
                  checked={gstApplicable}
                  onChange={(e) => {
                    const applicable = e.target.checked;

                    setGstApplicable(applicable);
                    setIsDirty(true);

                    setFormData((prev) => ({
                      ...prev,
                      comgst: applicable
                        ? prev.comgst.toUpperCase() === "N/A"
                          ? ""
                          : prev.comgst
                        : "N/A",
                    }));

                    SetErrors((prev) => ({
                      ...prev,
                      comgst: "",
                      companyGstinFile: "",
                    }));

                    if (!applicable) {
                      setDocumentFiles((prev) => ({
                        ...prev,
                        companyGstinFile: null,
                      }));
                    }
                  }}
                />

                <label htmlFor="gstApplicable" className="form-check-label">
                  GST Applicable
                </label>
              </div>

              <input
                name="comgst"
                value={formData.comgst}
                onChange={handleChange}
                disabled={!gstApplicable}
                className={`form-control mb-1 ${
                  errors.comgst ? "is-invalid" : ""
                }`}
                placeholder={gstApplicable ? "Company's GST Number" : "N/A"}
              />

              {errors.comgst && (
                <div className="text-danger mb-3">{errors.comgst}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label ">
                Upload GST Registration Certificate{" "}
                <span className="text-danger">*</span>
              </label>

              <label
                className="document-upload-box"
                htmlFor="companyGstinFile"
                style={{
                  opacity: gstApplicable ? 1 : 0.5,
                  pointerEvents: gstApplicable ? "auto" : "none",
                  cursor: gstApplicable ? "pointer" : "not-allowed",
                }}
              >
                <i className="bi bi-file-earmark-arrow-up upload-icon"></i>

                <span className="upload-title">
                  {documentFiles.companyGstinFile
                    ? documentFiles.companyGstinFile.name
                    : "Choose GST certificate file"}
                </span>

                <span className="upload-hint">
                  PDF, JPG or PNG · Maximum 5 MB
                </span>
              </label>

              <input
                id="companyGstinFile"
                type="file"
                hidden
                accept=".pdf,.jpg,.jpeg,.png"
                disabled={!gstApplicable}
                onChange={(e) =>
                  handleDocumentFileChange(e, "companyGstinFile")
                }
              />

              {gstApplicable && errors.companyGstinFile && (
                <div className="text-danger mt-2">
                  {errors.companyGstinFile}
                </div>
              )}

              {gstApplicable && documentPaths.companyGstinFilePath && (
                <div className="mt-2">
                  <a
                    href={RegistrationService.getDocumentUrl(
                      documentPaths.companyGstinFilePath,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open existing GST document
                  </a>
                </div>
              )}
            </div>
          </>
        );

      case 2:
        return (
          <>
            <h5 className="card-title mb-4">License Details</h5>
            <label htmlFor="licenseNo" className="form-label">
              Drug Wholesaler License Number (If Any)
            </label>
            <div className="row">
              <div className="col-md-6">
                <input
                  name="dwlic"
                  value={formData.dwlic}
                  onChange={handleChange}
                  maxLength={30}
                  className="form-control mb-2"
                  placeholder="License Number"
                />
                {errors.dwlic && (
                  <div className="text-danger">{errors.dwlic}</div>
                )}
              </div>
              <div className="col-md-3">
                <input
                  name="dwissue"
                  type="date"
                  value={formData.dwissue}
                  max={getTodayDate()}
                  onChange={handleChange}
                  className={`form-control mb-2 ${
                    errors.dwissue ? "is-invalid" : ""
                  }`}
                  placeholder="Issue Date"
                />

                {errors.dwissue && (
                  <div className="text-danger">{errors.dwissue}</div>
                )}
              </div>

              <div className="col-md-3">
                <input
                  name="dwexpairy"
                  type="date"
                  value={formData.dwexpairy}
                  onChange={handleChange}
                  className={`form-control mb-2 ${
                    errors.dwexpairy ? "is-invalid" : ""
                  }`}
                  placeholder="Expiry Date"
                />

                {errors.dwexpairy && (
                  <div className="text-danger">{errors.dwexpairy}</div>
                )}
              </div>
            </div>
            {/* ADD THE WHOLESALER LICENSE UPLOAD HERE */}

            <label className="form-label mt-2">
              Upload Drug Wholesaler License
            </label>

            <label className="document-upload-box">
              <input
                type="file"
                hidden
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleDocumentFileChange(e, "drugLicenseFile")}
              />

              <span className="document-upload-icon">
                <i className="bi bi-file-earmark-arrow-up"></i>
              </span>

              <span className="document-upload-filename">
                {documentFiles.drugLicenseFile?.name ||
                  "Choose License Document"}
              </span>

              <small>PDF, JPG or PNG · Maximum 5 MB</small>
              {documentPaths.drugLcnseFilePath && (
                <div className="mt-2">
                  <a
                    href={RegistrationService.getDocumentUrl(
                      documentPaths.drugLcnseFilePath,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open existing Drug Wholesaler License
                  </a>
                </div>
              )}
            </label>
            {errors.drugLicenseFile && (
              <div className="text-danger mt-2 mb-3">
                {errors.drugLicenseFile}
              </div>
            )}

            <label htmlFor="licenseNo" className="form-label">
              Drug VendorMfgLocation License Number (If Any)
            </label>
            <div className="row">
              <div className="col-md-6">
                <input
                  name="dmlic"
                  value={formData.dmlic}
                  onChange={handleChange}
                  maxLength={30}
                  className="form-control mb-2"
                  placeholder="License Number"
                />
                {errors.dmlic && (
                  <div className="text-danger">{errors.dmlic}</div>
                )}
              </div>
              <div className="col-md-3">
                <input
                  name="dmissue"
                  type="date"
                  value={formData.dmissue}
                  max={getTodayDate()}
                  onChange={handleChange}
                  className={`form-control mb-2 ${
                    errors.dmissue ? "is-invalid" : ""
                  }`}
                  placeholder="Issue Date"
                />

                {errors.dmissue && (
                  <div className="text-danger">{errors.dmissue}</div>
                )}
              </div>

              <div className="col-md-3">
                <input
                  name="dmexpairy"
                  type="date"
                  value={formData.dmexpairy}
                  onChange={handleChange}
                  className={`form-control mb-2 ${
                    errors.dmexpairy ? "is-invalid" : ""
                  }`}
                  placeholder="Expiry Date"
                />

                {errors.dmexpairy && (
                  <div className="text-danger">{errors.dmexpairy}</div>
                )}
              </div>

              <label className="form-label mt-2">
                Upload Drug Manufacturing License
              </label>

              <label className="document-upload-box">
                <input
                  type="file"
                  hidden
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) =>
                    handleDocumentFileChange(e, "drugLicense2File")
                  }
                />

                <span className="document-upload-icon">
                  <i className="bi bi-file-earmark-arrow-up"></i>
                </span>

                <span className="document-upload-filename">
                  {documentFiles.drugLicense2File?.name ||
                    "Choose Manufacturing License Document"}
                </span>

                <small>PDF, JPG or PNG · Maximum 5 MB</small>
                {documentPaths.drugLcnse2FilePath && (
                  <div className="mt-2">
                    <a
                      href={RegistrationService.getDocumentUrl(
                        documentPaths.drugLcnse2FilePath,
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open existing Drug Manufacturing License
                    </a>
                  </div>
                )}
              </label>
              {errors.drugLicense2File && (
                <div className="text-danger mt-2 mb-3">
                  {errors.drugLicense2File}
                </div>
              )}
            </div>
            <fieldset className="border p-3 mb-4">
              <legend className="w-auto px-1">Other License (If Any)</legend>
              <table className="table table-bordered table-sm mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "35%" }}>License Number</th>
                    <th style={{ width: "25%" }}>Issue Date</th>
                    <th style={{ width: "25%" }}>Expiry Date</th>
                    <th style={{ width: "20%" }}>License Document</th>
                    <th style={{ width: "15%" }} className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {otherlic.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          //className={`form-control form-control-sm ${otherLicErrors.otherlicno && index === otherlic.length - 1 ? "is-invalid" : ""}`}
                          className={`form-control form-control-sm ${
                            otherLicErrors[index]?.otherlicno
                              ? "is-invalid"
                              : ""
                          }`}
                          name="otherlicno"
                          value={item.otherlicno}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              otherlic,
                              setotherlic,
                            )
                          }
                          maxLength={30}
                          readOnly={item.readonly}
                          placeholder="License Number"
                        />
                        {otherLicErrors[index]?.otherlicno && (
                          <div className="invalid-feedback">
                            {otherLicErrors[index]?.otherlicno}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="date"
                          max={getTodayDate()}
                          className={`form-control form-control-sm ${
                            otherLicErrors[index]?.otherlicissue
                              ? "is-invalid"
                              : ""
                          }`}
                          name="otherlicissue"
                          value={item.otherlicissue}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              otherlic,
                              setotherlic,
                            )
                          }
                          readOnly={item.readonly}
                        />
                        {otherLicErrors[index]?.otherlicissue && (
                          <div className="invalid-feedback">
                            {otherLicErrors[index]?.otherlicissue}
                          </div>
                        )}{" "}
                      </td>
                      <td>
                        <input
                          type="date"
                          className={`form-control form-control-sm ${
                            otherLicErrors[index]?.otherlicexpiry
                              ? "is-invalid"
                              : ""
                          }`}
                          name="otherlicexpiry"
                          value={item.otherlicexpiry}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              otherlic,
                              setotherlic,
                            )
                          }
                          readOnly={item.readonly}
                        />
                        {otherLicErrors[index]?.otherlicexpiry && (
                          <div className="invalid-feedback">
                            {otherLicErrors[index]?.otherlicexpiry}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          accept=".pdf,.jpg,.jpeg,.png"
                          disabled={item.readonly}
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;

                            const extension = file.name
                              .split(".")
                              .pop()
                              .toLowerCase();
                            const allowedExtensions = [
                              "pdf",
                              "jpg",
                              "jpeg",
                              "png",
                            ];

                            if (!allowedExtensions.includes(extension)) {
                              alert(
                                "Only PDF, JPG, JPEG and PNG files are allowed.",
                              );
                              e.target.value = "";
                              return;
                            }

                            if (file.size > 5 * 1024 * 1024) {
                              alert("File size must not exceed 5 MB.");
                              e.target.value = "";
                              return;
                            }

                            setotherlic((prev) =>
                              prev.map((row, i) =>
                                i === index
                                  ? { ...row, licenseFile: file }
                                  : row,
                              ),
                            );

                            setIsDirty(true);
                          }}
                        />
                        {item.LicenseFilePath && (
                          <div className="mt-2">
                            <a
                              href={RegistrationService.getDocumentUrl(
                                item.LicenseFilePath,
                              )}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open existing Other License document
                            </a>
                          </div>
                        )}

                        {item.licenseFile && (
                          <small className="text-muted">
                            {item.licenseFile.name}
                          </small>
                        )}
                      </td>
                      <td className="text-center">
                        {index === otherlic.length - 1 && !item.readonly ? (
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-1"
                            onClick={handleAddOtherlic}
                            title="Add"
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm me-1"
                              onClick={() => handleEditOtherLic(index)}
                              title={item.readonly ? "Edit" : "Save"}
                            >
                              <i
                                className={`bi ${item.readonly ? "bi-pencil" : "bi-check-lg"}`}
                              ></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                deleteRow(index, otherlic, setotherlic)
                              }
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </fieldset>
            <fieldset className="border p-3 mb-4">
              <legend className="w-auto px-2">
                Your turnover for the last three years
              </legend>
              <div className="row">
                <div className="col-md-6">
                  <input
                    name="ogname"
                    value={formData.firstyear}
                    onChange={handleChange}
                    className="form-control mb-2"
                    placeholder="Person Name"
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="firstamount"
                    value={formData.firstamount}
                    onChange={handleChange}
                    maxLength={12}
                    className="form-control mb-2"
                    placeholder="Amount"
                  />
                  {errors.firstamount && (
                    <div className="invalid-feedback d-block">
                      {errors.firstamount}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <input
                    name="ogname2"
                    value={formData.secondyear}
                    onChange={handleChange}
                    className="form-control mb-2"
                    placeholder="Person Name"
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="secondamount"
                    value={formData.secondamount}
                    onChange={handleChange}
                    maxLength={12}
                    className="form-control mb-2"
                    placeholder="Amount"
                  />
                  {errors.secondamount && (
                    <div className="invalid-feedback d-block">
                      {errors.secondamount}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <input
                    name="ogname2"
                    value={formData.thirdyear}
                    onChange={handleChange}
                    className="form-control mb-2"
                    placeholder="Person Name"
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <input
                    name="thirdamount"
                    value={formData.thirdamount}
                    onChange={handleChange}
                    maxLength={12}
                    className="form-control mb-2"
                    placeholder="Amount"
                  />
                  {errors.thirdamount && (
                    <div className="invalid-feedback d-block">
                      {errors.thirdamount}
                    </div>
                  )}
                </div>
              </div>
            </fieldset>
            <label htmlFor="VendorAddrs" className="form-label">
              Brief details of your production/VendorMfgLocation details
              (personnel/machinery – machineries used/manpower in your
              organisation)<span className="text-danger">*</span>
            </label>
            <textarea
              name="brief"
              value={formData.brief}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === "*") {
                  e.preventDefault();
                }
              }}
              className={`form-control mb-1 ${errors.brief ? "is-invalid" : ""}`}
            />
            {errors.brief && <div className="text-danger">{errors.brief}</div>}
          </>
        );

      case 3:
        return (
          <>
            <h5 className="card-title mb-4">Material Details</h5>
            {/* <fieldset className="border p-3 mb-4"> */}
            <fieldset
              className={`border p-3 mb-2 ${rmErrors._fieldset ? "border-danger" : ""}`}
            >
              <legend className="w-auto px-1">
                Material Details <span className="text-danger">*</span>{" "}
              </legend>
              <table className="table table-bordered table-sm mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "35%" }}>Material Name</th>
                    <th style={{ width: "20%" }}>Min Pack Size</th>
                    <th style={{ width: "20%" }}>Max Pack Size</th>
                    <th style={{ width: "25%" }} className="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Rawmaterial.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${
                            rmErrors.rmname && rmErrorIndex === index
                              ? "is-invalid"
                              : ""
                          }`}
                          name="rmname"
                          value={item.rmname}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              Rawmaterial,
                              setrm,
                            )
                          }
                          readOnly={item.readonly}
                          placeholder="Material Name"
                          maxLength={100}
                        />
                        {rmErrors.rmname && rmErrorIndex === index && (
                          <div className="invalid-feedback">
                            {rmErrors.rmname}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          className={`form-control form-control-sm ${rmErrors.minqty && rmErrorIndex === index ? "is-invalid" : ""}`}
                          name="minqty"
                          value={item.minqty}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              Rawmaterial,
                              setrm,
                            )
                          }
                          readOnly={item.readonly}
                          placeholder="Min Quantity"
                        />
                        {rmErrors.minqty && rmErrorIndex === index && (
                          <div className="invalid-feedback">
                            {rmErrors.minqty}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          className={`form-control form-control-sm ${rmErrors.maxqty && rmErrorIndex === index ? "is-invalid" : ""}`}
                          name="maxqty"
                          value={item.maxqty}
                          onChange={(e) =>
                            handleCustomChangeDirty(
                              index,
                              e,
                              Rawmaterial,
                              setrm,
                            )
                          }
                          readOnly={item.readonly}
                          placeholder="Max Quantity"
                        />
                        {rmErrors.maxqty && rmErrorIndex === index && (
                          <div className="invalid-feedback">
                            {rmErrors.maxqty}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        {index === Rawmaterial.length - 1 && !item.readonly ? (
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-1"
                            onClick={handleAddrm}
                            title="Add"
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm me-1"
                              onClick={() => handleEditRawMaterial(index)}
                              title={item.readonly ? "Edit" : "Save"}
                            >
                              <i
                                className={`bi ${item.readonly ? "bi-pencil" : "bi-check-lg"}`}
                              ></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                deleteRow(index, Rawmaterial, setrm)
                              }
                              title="Delete"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </fieldset>
            {rmErrors._fieldset && (
              <div className="text-danger mt-2">{rmErrors._fieldset}</div>
            )}
          </>
        );

      case 4:
        return (
          <>
            <h5 className="card-title mb-4">Payment Details</h5>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
              className={`form-control mb-2 ${errors.paymentMethod ? "is-invalid" : ""}`}
            >
              <option value="">
                -- Select Payment Method <span className="text-danger">*</span>{" "}
                --{" "}
              </option>
              <option value="Cheque">Cheque</option>
              <option value="NEFT">NEFT</option>
              <option value="RTGS">RTGS</option>
              <option value="Cash">Cash</option>
            </select>
            {errors.paymentMethod && (
              <div className="text-danger mb-2">{errors.paymentMethod}</div>
            )}
            <label htmlFor="infavor" className="form-label">
              In Favor Of
              {formData.paymentMethod && <span className="text-danger">*</span>}
            </label>
            <input
              name="infavor"
              value={formData.infavor}
              onChange={(e) => {
                let value = e.target.value;

                // Allow N, N/, N/A (case-insensitive)
                if (/^N\/?A?$/i.test(value)) {
                  e.target.value = value;
                  handleChange(e);
                  return;
                }

                // Allow only letters, spaces and dots
                value = value.replace(/[^A-Za-z.\s]/g, "");

                // Do not allow dot or space at the beginning
                value = value.replace(/^[.\s]+/, "");

                e.target.value = value;
                handleChange(e);
              }}
              maxLength={100}
              className={`form-control mb-2 ${errors.infavor ? "is-invalid" : ""}`}
              placeholder="In Favor Of"
            />
            {errors.infavor && (
              <div className="text-danger mb-2">{errors.infavor}</div>
            )}
            <label htmlFor="bankname" className="form-label">
              Name Of The Bank
              {isBankRequired() && <span className="text-danger">*</span>}
            </label>
            <input
              name="bankname"
              value={formData.bankname}
              onChange={(e) => {
                let value = e.target.value;

                // Allow only letters, spaces and dots
                value = value.replace(/[^A-Za-z.\s]/g, "");

                // Do not allow dot or space at the beginning
                value = value.replace(/^[.\s]+/, "");

                e.target.value = value;
                handleChange(e);
              }}
              maxLength={100}
              className={`form-control mb-2 ${errors.bankname ? "is-invalid" : ""}`}
              placeholder="Name Of The Bank"
            />
            {errors.bankname && (
              <div className="text-danger mb-2">{errors.bankname}</div>
            )}
            <label htmlFor="accountNo" className="form-label">
              Full Account Number
              {isBankRequired() && <span className="text-danger">*</span>}
            </label>
            <input
              name="accountNo"
              value={formData.accountNo}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 18);

                handleChange(e);
              }}
              className={`form-control mb-2 ${errors.accountNo ? "is-invalid" : ""}`}
              placeholder="Full Account Number"
            />
            {errors.accountNo && (
              <div className="text-danger mb-2">{errors.accountNo}</div>
            )}
            <label htmlFor="ifscCode" className="form-label">
              IFSC Code
              {isIFSCRequired() && <span className="text-danger">*</span>}
            </label>
            <input
              name="ifscCode"
              value={formData.ifscCode}
              onChange={(e) => {
                e.target.value = e.target.value.toUpperCase();
                handleChange(e);
              }}
              className={`form-control mb-2 ${errors.ifscCode ? "is-invalid" : ""}`}
              placeholder="IFSC Code"
            />
            {errors.ifscCode && (
              <div className="text-danger mb-2">{errors.ifscCode}</div>
            )}
            <label htmlFor="micrCode" className="form-label">
              MICR Code (If Required)
            </label>
            <input
              name="micrCode"
              value={formData.micrCode}
              onChange={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 9);
                handleChange(e);
              }}
              className={`form-control mb-2 ${errors.micrCode ? "is-invalid" : ""}`}
              placeholder="MICR Code"
            />
            {errors.micrCode && (
              <div className="text-danger mb-2">{errors.micrCode}</div>
            )}
          </>
        );

      case 5:
        return (
          <>
            <h5 className="card-title mb-4">Declaration</h5>
            <label htmlFor="discountstracture" className="form-label">
              Discount Structure
            </label>
            <textarea
              name="discountstracture"
              value={formData.discountstracture}
              onChange={handleChange}
              className="form-control mb-3"
              placeholder="Discount Structure"
            />
            <label htmlFor="tranfac" className="form-label">
              Transport Facility
            </label>
            <textarea
              name="tranfac"
              value={formData.tranfac}
              onChange={handleChange}
              className="form-control mb-3"
              placeholder="Transport Facility"
            />
            <label htmlFor="certificate" className="form-label">
              Do you supply certificate of analysis with product?
            </label>
            <textarea
              name="certificate"
              value={formData.certificate}
              onChange={handleChange}
              className="form-control mb-3"
              placeholder="certificate of analysis"
            />
          </>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "90vh" }}
      >
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div className="container-fluid d-flex justify-content-center">
      <div
        className="form-wrapper border rounded shadow"
        style={{
          width: "100%",
          maxWidth: "900px",
          height: "95vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {isSaving && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255,255,255,0.75)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="text-center">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              ></div>

              <div className="mt-2 fw-semibold">Saving...</div>
            </div>
          </div>
        )}
        {/* MUI Stepper */}
        <Box sx={{ width: "100%", maxWidth: "900px", py: 2 }}>
          <Stepper activeStep={activeCard - 1} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={StepIconComponent}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Scrollable Form Card */}
        <div
          className="card shadow p-4"
          style={{ height: "calc(95vh - 80px)", overflowY: "auto" }}
        >
          <fieldset
            disabled={props.mode === "view"}
            style={{ border: "none", padding: 0 }}
          >
            {renderCard()}
          </fieldset>

          <div className="d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary"
              onClick={handlePrevious}
              disabled={activeCard === 1}
            >
              Previous
            </button>

            {activeCard < 5 ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleNext}
              >
                Next
              </button>
            ) : (
              props.mode !== "view" && (
                <button className="btn btn-success" onClick={handleSubmit}>
                  Submit
                </button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
